<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium">Questions to ask me...</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <div v-if="! edit" class="w-full flex items-center justify-between">
        <div>
          <ul class="list-disc flex flex-col space-y-3 pl-4" v-if="guest.questions.length">
            <li v-for="(question, index) in guest.questions" :key="`question-list-${index}`" class="text-blue-800 font-medium">
              {{ question }}
            </li>
          </ul>
          <div v-else class="flex items-center text-sm text-gray-500">
            No questions added.
          </div>
        </div>
        <Edit @edit="edit = true"/>
      </div>
      <div v-else class="w-full">
        <ValidationObserver ref="questionsForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(update)" method="post">
            <div v-if="! form.questions.length" class="h-12 text-sm text-gray-500">
              No questions added.
            </div>
            <div>
                <div class="flex mb-4" v-for="(item, index) in form.questions" :key="`list-item-${index}`">
                  <div class="w-full mr-3">
                    <ValidationProvider mode="eager" rules="required" name="Question" :vid="`question.${index}`" v-slot="{ errors }">
                      <div>
                        <input type="text" class="guestio-form-input w-full" :class="{'error-class': errors.length}" placeholder="Type or paste question" v-model="form.questions[index]">
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="w-1/12 my-auto">
                    <button class="rounded-full bg-gray-50 flex justify items-center p-2 hover:bg-softGray" @click.prevent="removeItem(index)">
                      <CrossIcon :classes="'w-6'"/>
                    </button>
                  </div>
                </div>
                <button type="button" class="text-pink-500  underline" @click.prevent="addItem">Add question +</button>
            </div>
            <div class="mt-4 flex items-center justify-end">
              <SaveOrCancel @cancel="edit = false" :working="working"/>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import CrossIcon from "@/components/svgs/CrossIcon"
  import Edit from "@/components/shared/Edit";
  import SaveOrCancel from "@/components/shared/SaveOrCancel";

  export default {
    components: {CrossIcon, Edit, SaveOrCancel},

    data() {
      return {
        working: false,
        edit: false,
        form: {
          questions: null,
        }
      }
    },

    watch: {  
      edit(edit) {
        if (edit) return

        this.form.questions = this.guest.questions
      }
    },

    mounted() {
      this.form.questions = this.user.guest.questions
      this.form.id = this.user.guest.id
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch('guest/updateGuest', this.form)
          .then(() => {
            this.working = false
            this.edit = false
          })
          .catch(error => {
            this.working = false
            if (error.response) {
              this.$refs.questionsForm.setErrors(error.response.data.errors)
            }
          })
      },

      addItem() {
        this.form.questions.push('')
      },

      removeItem(index) {
        this.form.questions.splice(index, 1)
      }
    },

    computed: {
      ...mapState({
        guest: state => state.guest.guest,
        user: state => state.auth.user
      }),
    },
  }
</script>

<style scoped>
  input.error-class {
    @apply border;
    border-color: #FF2F3B !important;
    background-color: #fff5f5 !important;
  }
</style>